module.exports = __webpack_public_path__ + "Logo3-35afd43179c70577f86d55f7a3715010.png";